import { render, staticRenderFns } from "./OPrototypeNavigation.vue?vue&type=template&id=923523c2&scoped=true&"
import script from "./OPrototypeNavigation.vue?vue&type=script&lang=js&"
export * from "./OPrototypeNavigation.vue?vue&type=script&lang=js&"
import style0 from "./OPrototypeNavigation.vue?vue&type=style&index=0&id=923523c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923523c2",
  null
  
)

export default component.exports